/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import { css, jsx } from '@emotion/react'; // eslint-disable-line @atlaskit/ui-styling-standard/use-compiled

import { HeadingItem } from '@atlaskit/menu';
import { ContextualToolbarIcon } from './icons/ContextualToolbarIcon';
import { FixedToolbarIcon } from './icons/FixedToolbarIcon';
// New editor controls
export var getOverflowFloatingToolbarConfig = function getOverflowFloatingToolbarConfig(_ref) {
  var api = _ref.api;
  return [{
    type: 'separator'
  }, {
    type: 'overflow-dropdown',
    options: [{
      type: 'separator'
    }, {
      type: 'overflow-dropdown-heading',
      title: 'Toolbar position'
    }, {
      title: 'Contextual',
      onClick: function onClick() {
        var _api$selectionToolbar, _api$selectionToolbar2, _api$selectionToolbar3;
        return (_api$selectionToolbar = api === null || api === void 0 || (_api$selectionToolbar2 = api.selectionToolbar.actions) === null || _api$selectionToolbar2 === void 0 || (_api$selectionToolbar3 = _api$selectionToolbar2.setToolbarDocking) === null || _api$selectionToolbar3 === void 0 ? void 0 : _api$selectionToolbar3.call(_api$selectionToolbar2, 'none')) !== null && _api$selectionToolbar !== void 0 ? _api$selectionToolbar : false;
      },
      icon: jsx(ContextualToolbarIcon, {
        label: "Contextual toolbar"
      })
    }, {
      title: 'Fixed at top',
      onClick: function onClick() {
        var _api$selectionToolbar4, _api$selectionToolbar5, _api$selectionToolbar6;
        return (_api$selectionToolbar4 = api === null || api === void 0 || (_api$selectionToolbar5 = api.selectionToolbar.actions) === null || _api$selectionToolbar5 === void 0 || (_api$selectionToolbar6 = _api$selectionToolbar5.setToolbarDocking) === null || _api$selectionToolbar6 === void 0 ? void 0 : _api$selectionToolbar6.call(_api$selectionToolbar5, 'top')) !== null && _api$selectionToolbar4 !== void 0 ? _api$selectionToolbar4 : false;
      },
      icon: jsx(FixedToolbarIcon, {
        label: "Fixed toolbar"
      })
    }]
  }];
};
export var getOverflowPrimaryToolbarConfig = function getOverflowPrimaryToolbarConfig(_ref2) {
  var api = _ref2.api;
  return [{
    items: [{
      content:
      // eslint-disable-next-line @atlaskit/design-system/use-primitives
      jsx("div", {
        css: headingContainerStyles
      }, jsx(HeadingItem, null, "Toolbar position")),
      value: {
        name: ''
      },
      isDisabled: true
    }, {
      content: 'Contextual',
      value: {
        name: 'contextual'
      },
      onClick: function onClick() {
        var _api$selectionToolbar7, _api$selectionToolbar8, _api$selectionToolbar9;
        return (_api$selectionToolbar7 = api === null || api === void 0 || (_api$selectionToolbar8 = api.selectionToolbar.actions) === null || _api$selectionToolbar8 === void 0 || (_api$selectionToolbar9 = _api$selectionToolbar8.setToolbarDocking) === null || _api$selectionToolbar9 === void 0 ? void 0 : _api$selectionToolbar9.call(_api$selectionToolbar8, 'none')) !== null && _api$selectionToolbar7 !== void 0 ? _api$selectionToolbar7 : false;
      }
    }, {
      content: 'Fixed at top',
      value: {
        name: 'fixed'
      },
      onClick: function onClick() {
        var _api$selectionToolbar10, _api$selectionToolbar11, _api$selectionToolbar12;
        return (_api$selectionToolbar10 = api === null || api === void 0 || (_api$selectionToolbar11 = api.selectionToolbar.actions) === null || _api$selectionToolbar11 === void 0 || (_api$selectionToolbar12 = _api$selectionToolbar11.setToolbarDocking) === null || _api$selectionToolbar12 === void 0 ? void 0 : _api$selectionToolbar12.call(_api$selectionToolbar11, 'top')) !== null && _api$selectionToolbar10 !== void 0 ? _api$selectionToolbar10 : false;
      }
    }]
  }];
};
var headingContainerStyles = css({
  padding: "var(--ds-space-100, 8px)".concat(" 0"),
  margin: "var(--ds-space-negative-100, -8px)".concat(" 0")
});